import React from 'react';
import { FaCheckCircle, FaClock, FaTimesCircle, FaExclamationTriangle } from 'react-icons/fa';

const StatusBadge = ({ status, size = 'md' }) => {
  const getStatusConfig = (status) => {
    const statusLower = status?.toLowerCase();
    
    switch (statusLower) {
      case 'approved':
      case 'completed':
      case 'delivered':
      case 'paid':
      case 'active':
        return {
          bg: 'bg-green-100',
          text: 'text-green-700',
          border: 'border-green-300',
          icon: <FaCheckCircle className="text-green-600" />,
          label: status === 'approved' ? 'Approved' : status === 'completed' ? 'Completed' : status === 'delivered' ? 'Delivered' : status === 'paid' ? 'Paid' : 'Active'
        };
      
      case 'pending':
      case 'processing':
      case 'confirmed':
      case 'shipped':
        return {
          bg: 'bg-yellow-100',
          text: 'text-yellow-700',
          border: 'border-yellow-300',
          icon: <FaClock className="text-yellow-600" />,
          label: status === 'pending' ? 'Pending' : status === 'processing' ? 'Processing' : status === 'confirmed' ? 'Confirmed' : 'Shipped'
        };
      
      case 'rejected':
      case 'cancelled':
      case 'failed':
      case 'suspended':
        return {
          bg: 'bg-red-100',
          text: 'text-red-700',
          border: 'border-red-300',
          icon: <FaTimesCircle className="text-red-600" />,
          label: status === 'rejected' ? 'Rejected' : status === 'cancelled' ? 'Cancelled' : status === 'failed' ? 'Failed' : 'Suspended'
        };
      
      case 'partially_processed':
        return {
          bg: 'bg-blue-100',
          text: 'text-blue-700',
          border: 'border-blue-300',
          icon: <FaExclamationTriangle className="text-blue-600" />,
          label: 'Partially Processed'
        };
      
      default:
        return {
          bg: 'bg-gray-100',
          text: 'text-gray-700',
          border: 'border-gray-300',
          icon: <FaClock className="text-gray-600" />,
          label: status || 'Unknown'
        };
    }
  };

  const config = getStatusConfig(status);
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1.5',
    lg: 'text-base px-4 py-2'
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 ${config.bg} ${config.text} ${config.border} border rounded-full font-medium ${sizeClasses[size]}`}
    >
      <span className="flex-shrink-0">{config.icon}</span>
      <span>{config.label}</span>
    </span>
  );
};

export default StatusBadge;



